import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'
import { observer } from 'mobx-react'
import NFEPage from './4nfe/NFEPage'
import ReinfPage from './4reinf/ReinfPage'
import NFSPage from './4nfs/NFSPage'

const ProductsRouter = withRouter(observer((props) => {
  const { url } = props.match
  return (
    <Switch>
      <Route path={`${url}/4NFE`} render={() => <NFEPage />} />
      <Route path={`${url}/4REINF`} render={() => <ReinfPage />} />
      <Route path={`${url}/4NFSE`} render={() => <NFSPage />} />
      <Route render={() => <div>404 not found</div>} />
    </Switch>
  )
}))

export default ProductsRouter



// WEBPACK FOOTER //
// ./src/components/dashboard/products/ProductsRouter.js